import React, {useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import DashboardComponent from './dashboardComponent';
import {getOpenItem} from '../../../app/store/reducers/menu';
import {getDashboardCommunities, getDashboardCommunity} from '../../../app/store/reducers/dashboard';
import {getCommunityLoadingStatus} from '../../../app/store/reducers/loading';
import {getIsStakeAdmin, getTeamMemberRole} from '../../../app/store/reducers/session';

const CommunityDashboard = ({createHandleMenuClick}) => {
    const type = 'communities';
    const openItem = useSelector(getOpenItem);
    const dashboardCommunity = useSelector(getDashboardCommunity);
    const dashboardCommunities = useSelector(getDashboardCommunities);
    const isActive = openItem === type.toLowerCase();
    const communitiesLoadingStatus = useSelector(getCommunityLoadingStatus);
    const userRole = useSelector(getTeamMemberRole);
    const isStakeAdmin = useSelector(getIsStakeAdmin);

    const fCommunities = useMemo(() => {
        const communities = [...dashboardCommunities].map((c) => ({sfid: c.sfid, name: c.name}));

        if (communities.length <= 1) {
            return communities;
        }

        return [{sfid: 'all', name: `All communities (${dashboardCommunities.length || 0})`}, ...communities];
    }, [dashboardCommunities, isStakeAdmin, userRole]);

    return (
        <DashboardComponent
            type={type}
            dashboardObj={dashboardCommunity}
            isLoading={communitiesLoadingStatus.isLoading}
            isSuccess={communitiesLoadingStatus.isSuccess}
            data={fCommunities}
            createHandleMenuClick={createHandleMenuClick}
            isActive={isActive}
        />
    );
};

CommunityDashboard.propTypes = {
    createHandleMenuClick: PropTypes.func
};

export default CommunityDashboard;
